import { render } from "./LoadChat.vue?vue&type=template&id=13c6e5f4"
import script from "./LoadChat.vue?vue&type=script&lang=js"
export * from "./LoadChat.vue?vue&type=script&lang=js"

import "./LoadChat.vue?vue&type=style&index=0&id=13c6e5f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__